var map = {
	"./activity.svg": 5100,
	"./appointments.svg": 7562,
	"./glucose.svg": 96782,
	"./glucose/activity-icon-sm.svg": 77913,
	"./glucose/drugs-icon-sm.svg": 22888,
	"./glucose/glucose-empty.svg": 76017,
	"./glucose/glucose-icon-sm.svg": 84684,
	"./glucose/meal-icon-sm.svg": 40667,
	"./glucose/menu/activity-icon.svg": 80549,
	"./glucose/menu/blood-test.svg": 25048,
	"./glucose/menu/meal.svg": 43514,
	"./glucose/menu/tablets-icon.svg": 80465,
	"./menstruation-calendar.svg": 20930,
	"./pregnancy.svg": 30628,
	"./pregnancy/background.svg": 35034,
	"./pregnancy/pregnancy-banner.svg": 86447,
	"./pregnancy/woman.svg": 63213,
	"./pressure-empty.svg": 3029,
	"./pressure.svg": 3065,
	"./tablets-calendar.svg": 81235,
	"./vaccination.svg": 5614
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 92081;